import { Tag } from "antd";

interface StateMasterBadgeProps {
  stateMaster?: {
    name?: string | null;
    background_color?: string;
    text_color?: string;
  };
}

const StateMasterBadge: React.FC<StateMasterBadgeProps> = ({ stateMaster }) => {
  if (!stateMaster?.name) {
    return null;
  }
  const customStyle: React.CSSProperties = {
    backgroundColor: stateMaster.background_color,
    color: stateMaster.text_color,
    border: "none",
    padding: "4px 12px",
    borderRadius: "8px",
    fontWeight: 500,
    display: "inline-block",
    fontSize: "14px",
  };
  return <Tag style={customStyle}>{stateMaster.name}</Tag>;
};

export default StateMasterBadge;
